/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Getting_Started__NameInputs */

const en_help_center__getting_started__name = /** @type {(inputs: Help_Center__Getting_Started__NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting Started`)
};

/**
* | output |
* | --- |
* | "Getting Started" |
*
* @param {Help_Center__Getting_Started__NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__getting_started__name = /** @type {((inputs?: Help_Center__Getting_Started__NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Getting_Started__NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__getting_started__name(inputs)
});